import axios, { getEnv } from './api';

export const ConsultarEmpreendedorService = {
  find: async (cnpj) => {
    console.log('cnpj', cnpj);
    try {
      const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v1/integracao/app/empreendedores/${cnpj}`);
      return response.data;
    } catch (error) {
       throw error
    }
  }
};
